(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component_ProductForm"] && !Shopify.designMode) return;
  try {
    window.RechargeSubscriptionWidgetReady = (api) => {
    if (api.variantId && api.sellingPlanId) {
      const url = new URL(window.location);
      url.searchParams.set('selling_plan', api.sellingPlanId);
      url.searchParams.set('variant', api.variantId);
      window.history.replaceState({}, '', url);

      const sellingPlanChange = api.events.onSellingPlanChange((planId) => {
        if (!planId) {
          url.searchParams.delete('selling_plan');
        } else {
          url.searchParams.set('selling_plan', planId);
        }

        window.history.replaceState({}, '', url);
      });

      const variantChange = api.events.onVariantChange((variantId) => {
        url.searchParams.set('variant', api.variantId);
        window.history.replaceState({}, '', url);
      });
    }
  };
  } catch(e) { console.error(e); }
})();

})();
